import type {SchedulerDashboardActions} from 'src/action-creators/scheduler/dashboard';
import {SET_TEAM_MEMBER_ANALYTICS} from 'src/action-creators/scheduler/dashboard';

import type {TeamMemberIdAndDetails} from 'src/types/scheduler/dashboard';

import keyBy from 'lodash/keyBy';


export type SchedulerDashboardState = {
  teamMemberAnalytics: TeamMemberIdAndDetails;
};

export const initialState: SchedulerDashboardState = {
  teamMemberAnalytics: {},
};

export default function schedulerDashboard(
  state: SchedulerDashboardState = initialState,
  action: SchedulerDashboardActions,
): SchedulerDashboardState {
  switch (action.type) {
    case SET_TEAM_MEMBER_ANALYTICS:
      return {
        ...state,
        teamMemberAnalytics: keyBy(action.payload, 'agentId'),
      };
    default:
      return state;
  }
}
